
export default {
    props: {
        userId: {
            type: Number,
            required: true,
        },
    },
    data () {
        return {
            loading: false,
            saving: false,
            groups: [],
            selectedGroupId: null,
            groupFields: [
                { key: 'name', label: 'Group', sortable: true },
                { key: 'actions', label: '', sortable: false, class: 'text-right' },
            ],
        }
    },
    async mounted () {
        await this.loadGroups()
    },
    methods: {
        async loadGroups () {
            this.loading = true
            try {
                this.groups = await this.$api.getBrokerUserGroups(this.userId)
            } catch (e) {
                console.error('Failed to load broker groups:', e)
            }
            this.loading = false
        },
        async addGroup () {
            if (!this.selectedGroupId) return
            this.saving = true
            try {
                await this.$api.addBrokerGroup(this.userId, this.selectedGroupId)
                this.selectedGroupId = null
                await this.loadGroups()
            } catch (e) {
                console.error('Failed to add broker group:', e)
            }
            this.saving = false
        },
        async removeGroup (groupId) {
            this.saving = true
            try {
                await this.$api.removeBrokerGroup(this.userId, groupId)
                await this.loadGroups()
            } catch (e) {
                console.error('Failed to remove broker group:', e)
            }
            this.saving = false
        },
    },
}
